import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar-item',
  templateUrl: './sidebar-item.component.html',
  styleUrl: './sidebar-item.component.less',
})
export class SidebarItemComponent {
  @Input() item: any;
  @Output() onClick = new EventEmitter<string>(); // Emits the URL

  constructor(public router: Router) {}

  onButtonClick() {
    this.onClick.emit(this.item.url);
  }
}
